<app-navbar>
    <h2>{{"COMPANY.EDIT_TITLE" | translate}}</h2>
</app-navbar>

<div class="container">
    <app-check-current-user></app-check-current-user>
</div>

<div class="company-edit-profile light-grey-background pb-60">
    <div class="container">
        <form #editCompanyForm="ngForm" (ngSubmit)="updateCompanyData(editCompanyForm)" class="custom-form-one">
            <div class="form-section">
                <div class="form-section-title">
                    <h5 class="custom-section-title">{{"COMPANY.EDIT_DETAILS" | translate}}</h5>
                </div>
                <div class="form-block">
                    <div class="form-row">
                        <div class="form-group col-md-12">
                            <label for="companyName">{{"COMPANY.EDIT_NAME" | translate}}</label>
                            <input type="text" id="companyName" class="form-control" name="companyName"  #companyName='ngModel' [ngModel]=companyData.companyName required>
                            <div class="error-msg" *ngIf="!companyName.valid && companyName.touched || !companyName.valid && editCompanyForm.submitted">{{'VALIDATION.REQUIRED' | translate}}
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-12">
                            <label for="companyDescription">{{"COMPANY.EDIT_DESCRIPTION" | translate}}</label>
                            <angular-editor [(ngModel)]="htmlContent"
                                            name="companyDescription"
                                            id="companyDescription"
                                            [config]="editorConfig"
                                            #companyDescription='ngModel'
                                            required>
                            </angular-editor>
                            <div class="error-msg" *ngIf="(companyDescription.invalid && companyDescription.touched || companyDescription.invalid && editCompanyForm.submitted)">
                                {{'VALIDATION.REQUIRED' | translate}}
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-12">
                            <label>Logo</label>
                            <img src={{companyLogoPath}} alt="profile image" class="companyLogoImage" />

                            <label>{{"COMPANY.EDIT_LOGO" | translate}}</label>
                            <input type="file" class="form-control"  (change)="selectFile($event)" />
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="country">{{'LOGIN.COUNTRY' | translate}}</label>
                            <select (change)="changeCountry($event)"
                                    [ngModel]="companyData.country"
                                    class="form-control"
                                    id="country" name="country" #country='ngModel' required>
                                <option value="">{{'DROPDOWN.COUNTRY' | translate}}</option>
                                <option *ngFor="let country of countries">{{country.name}}</option>
                            </select>
                            <div class="error-msg" *ngIf="country.invalid && (country.touched || editCompanyForm.submitted)">
                                {{'VALIDATION.REQUIRED' | translate}}
                            </div>
                        </div>
                        <div class="form-group  col-md-6">
                            <label for="city">{{'JOBS.COUNTY' | translate}}</label>
                            <ng-select2
                                    [ngModel]="companyData.city"
                                    [data]="cities"
                                    [options]="singleSelectOp"
                                    name="city"
                                    #city='ngModel'
                                    id="city"
                                    required
                            >
                            </ng-select2>
                            <div class="error-msg" *ngIf="city.invalid && (city.touched || editCompanyForm.submitted)">
                                {{'VALIDATION.REQUIRED' | translate}}
                            </div>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-md-12">
                            <label for="companyAddress">{{'COMPANY.EDIT_ADRESS' | translate}}</label>
                            <input type="text" ngModel #companyAddress='ngModel' id="companyAddress" class="form-control" name="companyAddress" [ngModel]=companyData.companyAddress>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="fiscalCode">{{'COMPANY.FISCAL' | translate}}</label>
                            <input type="text" ngModel id="fiscalCode" class="form-control" name="fiscalCode" [ngModel]=companyData.fiscalCode #fiscalCode='ngModel' required>
                            <div class="error-msg" *ngIf="!fiscalCode.valid && fiscalCode.touched || !fiscalCode.valid && editCompanyForm.submitted">{{'VALIDATION.REQUIRED' | translate}}
                            </div>
                        </div>
                        <div class="form-group col-md-6">
                            <label>{{'COMPANY.TVA' | translate}}?</label>
                            <label for="vatCode" class="checkbox-container">{{'COMPANY.YES' | translate}}
                                <input type="checkbox" id="vatCode" name="vatCode" value='{{companyData.vatCode}}' [ngModel]=companyData.vatCode checked='{{companyData.vatCode}}'>
                                <span class="checkmark"></span>
                            </label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4 form-group" *ngIf="Domains">
                            <label>{{'COMPANY.DOMANI' | translate}}</label>
                            <select [ngModel]="selectedDomain" (change)="changeDomain($event)" class="form-control" name="activitySector">
                                <option *ngFor="let country of Domains">{{country.name}}</option>
                            </select>
                        </div>
                        <div class="col-md-4 form-group" *ngIf="subdomains">
                            <label>{{'COMPANY.SUBDOMANI' | translate}}</label>
                            <ng-select2

                                    [ngModel]="selectSubdomains"
                                    [data]="subDomainsArray"
                                    [options]="multiSelectOp"
                                    (valueChanged)="changeSubDomain($event)"
                                    name="companyActivitySubSector"
                            >
                            </ng-select2>
                        </div>
                        <div class="col-md-4 form-group" *ngIf="selected && categoriesArray.length > 0">
                            <label>{{'COMPANY.EDIT_CATEGORYES' | translate}}</label>
                            <ng-select2

                                    [ngModel]="selectedCategories"
                                    [data]="categoriesArray"
                                    [options]="multiSelectOp"
                                    name="companyMicroActivitySector"
                            >
                            </ng-select2>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="companyType">{{'COMPANY.TYPE' | translate}}</label>
                            <select name="companyType" id="companyType" class="form-control" [ngModel]=companyData.companyType>
                                <option value="">{{'DROPDOWN.OPTION' | translate}}</option>
                                <option value="entrepreneurial" [selected]="(companyData.companyType) === 'entrepreneurial'" >{{'COMPANY.EDIT_ENTREPRENURIAL' | translate}}</option>
                                <option value="multinational" [selected]="(companyData.companyType) === 'multinational'">{{'COMPANY.EDIT_MULTINATIONAL' | translate}}</option>
                                <option value="state" [selected]="(companyData.companyType) === 'state'">{{'COMPANY.EDIT_STATE' | translate}}</option>
                                <option value="mixed" [selected]="(companyData.companyType) === 'mixed'">{{'COMPANY.EDIT_MIXED' | translate}}</option>
                            </select>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="companyEmployeesLevel">{{'COMPANY.LEVEL_EMPLY' | translate}}</label>
                            <select name="companyEmployeesLevel" id="companyEmployeesLevel" class="form-control" [ngModel]=companyData.companyEmployeesLevel>
                                <option value="">{{'DROPDOWN.OPTION' | translate}}</option>
                                <option value="micro" [selected]="(companyData.companyEmployeesLevel) === 'micro'">{{'COMPANY.MICRO_EMPLY' | translate}}</option>
                                <option value="small" [selected]="(companyData.companyEmployeesLevel) === 'small'">{{'COMPANY.SMALL_EMPLY' | translate}}</option>
                                <option value="medium" [selected]="(companyData.companyEmployeesLevel) === 'medium'">{{'COMPANY.MEDIUM_EMPLY' | translate}}</option>
                                <option value="big" [selected]="(companyData.companyEmployeesLevel) === 'big'">{{'COMPANY.LARGE_EMPLY' | translate}}</option>
                            </select>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="companyRevenue">{{'COMPANY.LEVEL_INCOME' | translate}}</label>
                            <select name="companyRevenue" id="companyRevenue" class="form-control" [ngModel]=companyData.companyRevenue>
                                <option value="">{{'DROPDOWN.OPTION' | translate}}</option>
                                <option value="micro" [selected]="(companyData.companyRevenue) === 'micro'">{{'COMPANY.MICRO_INCOME' | translate}}</option>
                                <option value="small" [selected]="(companyData.companyRevenue) === 'small'">{{'COMPANY.SMALL_INCOME' | translate}}</option>
                                <option value="medium" [selected]="(companyData.companyRevenue) === 'medium'">{{'COMPANY.MEDIUM_INCOME' | translate}}</option>
                                <option value="big" [selected]="(companyData.companyRevenue) === 'big'">{{'COMPANY.LARGE_INCOME' | translate}}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-section pt-10">
                <div class="form-section-title">
                    <h5 class="custom-section-title">Social Media</h5>
                </div>
                <div class="form-block">
                    <div class="form-row" ngModelGroup="companySocialMedia" #companySocialMedia="ngModelGroup">
                        <div class="form-group col-md-6">
                            <label for="companyFacebook">Facebook</label>
                            <input type="url" pattern="https://.*" placeholder="https://exemplu.com" ngModel id="companyFacebook" class="form-control" name="companyFacebook" [ngModel]=companyFacebook>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="companyInstagram">Instagram</label>
                            <input type="url" pattern="https://.*" placeholder="https://exemplu.com" ngModel id="companyInstagram" class="form-control" name="companyInstagram" [ngModel]=companyInstagram>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="companyLinkedIn">LinkedIn</label>
                            <input type="url" pattern="https://.*" placeholder="https://exemplu.com" ngModel id="companyLinkedIn" class="form-control" name="companyLinkedIn" [ngModel]=companyLinkedIn>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="companyTikTok">Tik Tok</label>
                            <input type="url" pattern="https://.*" placeholder="https://exemplu.com" ngModel id="companyTikTok" class="form-control" name="companyTikTok" [ngModel]=companyTikTok>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="companyWebsite">Website</label>
                            <input type="url" pattern="https://.*" placeholder="https://exemplu.com" ngModel id="companyWebsite" class="form-control" name="companyWebsite" [ngModel]=companyWebsite>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="companyYouTube">Youtube</label>
                            <input type="url" pattern="https://.*" placeholder="https://exemplu.com" ngModel id="companyYouTube" class="form-control" name="companyYouTube" [ngModel]=companyYouTube>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-section pt-10">
                <div class="form-section-title">
                    <h5 class="custom-section-title">{{'COMPANY.EDIT_PLANTS' | translate}}</h5>
                </div>
                <div class="form-block">
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="employmentThisYear">{{'COMPANY.EDIT_CYEAR' | translate}}</label>
                            <input type="text" ngModel id="employmentThisYear" class="form-control" name="employmentThisYear" [ngModel]=companyData.employmentThisYear>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="employmentNextYear">{{'COMPANY.EDIT_NYEAR' | translate}}</label>
                            <input type="text" ngModel id="employmentNextYear" class="form-control" name="employmentNextYear" [ngModel]=companyData.employmentNextYear>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="employmentEmergencies">{{'COMPANY.EDIT_FAST' | translate}}</label>
                            <input type="text" ngModel id="employmentEmergencies" class="form-control" name="employmentEmergencies" [ngModel]=companyData.employmentEmergencies>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-section pt-10">
                <div class="form-section-title">
                    <h5 class="custom-section-title">{{'COMPANY.EDIT_REPRESENTATIVE' | translate}}</h5>
                </div>
                <div class="form-block">
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="administratorLastName">{{'LOGIN.LAST_NAME' | translate}}</label>
                            <input type="text" ngModel id="administratorLastName" class="form-control" name="administratorLastName" [ngModel]=companyData.administratorLastName>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="administratorFirstName">{{'LOGIN.FIRST_NAME' | translate}}</label>
                            <input type="text" ngModel id="administratorFirstName" class="form-control" name="administratorFirstName" [ngModel]=companyData.administratorFirstName>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="administratorTelephone">{{'COMPANY.EDIT_PHONE' | translate}}</label>
                            <input type="text" ngModel id="administratorTelephone" class="form-control" name="administratorTelephone" [ngModel]=companyData.administratorTelephone>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="administratorEmail">E-mail</label>
                            <input type="email" ngModel id="administratorEmail" class="form-control" name="administratorEmail" [ngModel]=companyData.administratorEmail>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="administratorFunction">{{'COMPANY.EDIT_POSITION' | translate}}</label>
                            <input type="text" ngModel id="administratorFunction" class="form-control" name="administratorFunction" [ngModel]=companyData.administratorFunction>
                        </div>
                    </div>
                </div>
            </div>
            <app-form-message [success]="formResponse" [customSuccessMessage]="customSuccessMessage" *ngIf="formSent"></app-form-message>
            <div class="form-row justify-content-end">
                <button type="submit" class="green-button">{{'COMPANY.EDIT_SAVE' | translate}}</button>
            </div>
        </form>
    </div>
</div>
<app-footer></app-footer>
